<template>
  <div class="container">
      <form class="confirm">
<label class="listOneRow"><p class="_title">お名前 (御担当者名)</p><p class="_content"><input type=text name="name" v-model="fields.name" disabled="disabled"></p></label>

<label class="listOneRow"><p class="_title">御社名</p><p class="_content"><input type=text name="name" v-model="fields.company" disabled="disabled"></p></label>

<label class="listOneRow"><p class="_title">部署名</p><p class="_content"><input type=text name="name" v-model="fields.department" disabled="disabled"></p></label>

<label class="listOneRow"><p class="_title">メールアドレス</p><p class="_content"><input type=text name="email" v-model="fields.mail" disabled="disabled"></p></label>

<label class="listOneRow"><p class="_title">電話番号 (任意)</p><p class="_content"><input type=text name="tel" v-model="fields.telephone" disabled="disabled"></p></label>

<div class="listOneRow">
  <label for="inqueryItem" class="_title">お問い合わせの項目<span class="brPc"></span> (複数可)</label>
  <div class="_content listMultiRow">
    <label class="">
      <input type="checkbox" name="inqueryItem" value="見積り依頼" v-model="fields.inquirys" disabled="disabled">見積り依頼
    </label>
    <label class="">
      <input type="checkbox" name="inqueryItem" value="採用について" v-model="fields.inquirys" disabled="disabled">採用について
    </label>
    <label class="">
      <input type="checkbox" name="inqueryItem" value="その他" v-model="fields.inquirys" disabled="disabled">その他
    </label>
  </div>
</div>

<label class="listOneRow lastRow">
  <p class="_title">お問い合わせの内容</p>
  <div class="_content">
    <p class=""><textarea name="comment" rows=6 wrap=soft v-model="fields.freeText" disabled="disabled"></textarea></p>
  </div>
</label>

<!--
<VueRecaptcha :sitekey="recaptchaKey" @verify="onVerify" @expired="onExpired" ref="recaptcha"></VueRecaptcha>
-->
<input type="button" value="送信する" class="nextToPhase buttonAction" @click="toThanks" :disabled="isDisabled">
<input type="button" value="戻る" class="backToPhase buttonAction" @click="toInput">
          </form>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha-v3'

export default {
  name:'phaseConfirm',
  props: {
    fields:{
      name:{
        type:String,
        required: true,
      }, 
      company:{
        type:String
      }, 
      department:{
        type:String
      }, 
      mail:{
        type:String,
        required: true,
        validator: function(val) {
          return res
        }
      }, 
      telephone:{
        type:String
      }, 
      inquirys:{
        type:Object,
        required: true,
      }, 
      freeText:{
        type:String,
        required: true,
        validator: function(val) {
          return val.lenght>0
        }
      }, 
    },
  },
	data() {
		return {
      isDisabled: false,
      recaptchaKey: "",
		}
	},
  components:{ VueRecaptcha,
  },	
  methods:{
    toInput() {
      this.$emit('changePhase', 'form-input')
    },
    toConfirm() {
      this.$emit('changePhase', 'form-confirm')
    },
    toThanks() {
      this.$emit('changePhase', 'form-thanks')
    },
    onVerify(response) {
      if(response !== '') {
        this.isDisabled = false
      } else {
        return false
      }
    },
    onExpired() {
      this.resetRecaptcha()
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset()
      this.isDisabled = true
    },
  }
}
</script>

<style>
</style>
